import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { TFunction } from "i18next";
import TableComponent from 'components/Table';
import React, { FC } from "react";
import { Link, useHistory } from "react-router-dom";
import { OrderProperty, PropertyLoanType } from "types/order";
import { LEDGER_CODE_LOAN_AMOUNT } from "utils/constants";
import { formatMoney } from "utils/helpers";

const useStyles = makeStyles((theme: any) => ({
  container: { marginTop: theme.spacing(2), marginBottom: theme.spacing(2) },
  primarycolorfonts: {
    fontWeight: 500,
    color: theme.palette.tab.offselected,
  },
  placeholderText: {
    color: theme.palette.tab.offselected,
    fontWeight: 500,
    textAlign: 'center',
    marginTop: theme.spacing(5),
  },
}));

type Props = {
  t: TFunction,
  orderId: string,
  selectedProperty: OrderProperty,
}

export const Loans: FC<Props> = ({
  t,
  orderId,
  selectedProperty
}) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Grid item container>
      <Typography variant="h6" className={classes.primarycolorfonts}>
        {t('orders:loans')}
      </Typography>
      {selectedProperty.loans && selectedProperty.loans?.length > 0 && (
        <TableComponent
          disabledBorderLeft
          cellAlignment="left"
          columns={{
            actions: {
              header: { title: t('orders:actionsLabel'), align: 'center', width: '80px' },
              renderer: ({ row }) => (
                <Box display="flex" justifyContent="center">
                  <IconButton
                    style={{ padding: 0 }}
                    onClick={() => history.push(`/orders/details/${orderId}/loans/${row._id}`)}
                    size="large"
                  >
                    <FontAwesomeIcon icon="external-link-alt" size="xs" />
                  </IconButton>
                </Box>
              ),
            },
            numer: {
              header: { title: t('orders:loan-number'), align: 'left', width: 'auto' },
              renderer: ({ row }) => (
                <Link to={`/orders/details/${orderId}/loans/${row._id}`}>{row.loan_number}</Link>
              ),
            },
            loanAmount: {
              header: { title: t('orders:amountLabel'), align: 'left' },
              // eslint-disable-next-line react/no-unused-prop-types
              renderer: ({ row }: { row: PropertyLoanType }) => {
                const loanAmountEntry = row.accounting.find((entry) =>
                  entry.code.startsWith(LEDGER_CODE_LOAN_AMOUNT)
                );
                return <>{formatMoney(loanAmountEntry?.amount ?? 0)}</>;
              },
            },
          }}
          dataSet={selectedProperty.loans || []}
        />
      )}
      {(!selectedProperty.loans || selectedProperty.loans.length === 0) && (
        <Typography className={classes.placeholderText}>{t('orders:noLoansMessage')}</Typography>
      )}
    </Grid>
  );
};
